/**
 * Mode d'affichage du portail.
 *
 * Valeurs sous forme de chaînes : le mode transite par `assets/config.json`,
 * il doit donc être sérialisable et lisible tel quel dans les devtools.
 */
export enum Mode {
  GESTIONNAIRE = 'gestionnaire',
  APPRENANT = 'apprenant',
}

/**
 * Décrit ce qui change d'un mode à l'autre, plutôt que de brancher sur le mode
 * dans les templates. Ajouter un mode revient à ajouter une entrée dans
 * {@link MODE_CONFIGURATIONS}, sans toucher au header ni au footer.
 */
export interface ModeConfiguration {
  /** Classe posée sur `<header>`, ciblée par le thème. */
  headerClass: string | null;
  /** Classe posée sur `<footer>`, ciblée par le thème. */
  footerClass: string | null;
  /** Application cible du lien porté par le logo (cf. `buildUrl`). */
  ageApp: string;
  /** Libellé accessible du lien logo. */
  logoLabel: string;
  /** Classe du lien logo ; `null` = logo historique dans un `<div>` enfant. */
  logoClass: string | null;
  /** Affiche l'icône du module à gauche du titre. */
  withModuleIcon: boolean;
  /** Le header pilote l'ouverture du menu latéral. */
  withMenu: boolean;
  /** Pied de page réduit (liens + copyright) au lieu du pied complet. */
  reducedFooter: boolean;
}

export const MODE_CONFIGURATIONS: Record<Mode, ModeConfiguration> = {
  [Mode.GESTIONNAIRE]: {
    headerClass: null,
    footerClass: null,
    ageApp: 'age',
    logoLabel: 'Pégase - accueil',
    logoClass: null,
    withModuleIcon: true,
    withMenu: true,
    reducedFooter: false,
  },
  [Mode.APPRENANT]: {
    headerClass: 'header-apprenant',
    footerClass: 'footer-apprenant',
    ageApp: 'aap',
    logoLabel: 'Pégase - accueil',
    logoClass: 'logo-apprenant',
    withModuleIcon: false,
    withMenu: false,
    reducedFooter: true,
  },
};